import { render, staticRenderFns } from "./facilitatorPage.vue?vue&type=template&id=486c4844&scoped=true&"
import script from "./facilitatorPage.vue?vue&type=script&lang=js&"
export * from "./facilitatorPage.vue?vue&type=script&lang=js&"
import style0 from "./facilitatorPage.vue?vue&type=style&index=0&id=486c4844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c4844",
  null
  
)

export default component.exports